export const isInnerPage = () => /appointment|appointments|profile|noInternet/.test(window.location.pathname);
